<div class="hb-container hb-container--width-lg">
  <div class="hb-grid hb-mb--xl">
    <div class="hb-cell hb-cell--12of12 hb-cell--3of12@md">
      <stat-filter (selectedFilters)="filterVisning($event)" seksjon="energitilskudd"></stat-filter>
    </div>

    <div class="hb-cell hb-cell--12of12 hb-cell--9of12@md">
      <h1 class="hb-h1 hb-text--3xl hb-avstand--avsnitt">Tilskudd til energitiltak</h1>
      <hb-accordion class="hb-mb--lg">
        <hb-accordion-element id="energitilskuddID">
          <h2 title class="hb-accordion-tittel">Om Tilskudd til energitiltak</h2>
          <div body="">
            <p><strong>Tilskudd til energitiltak i kommunale boliger og omsorgsbygg</strong></p>
            <p>
              Tilskuddet skal gå til gjennomføring av tiltak som reduserer behov for energi i kommunale utleieboliger, omsorgsboliger og sykehjem. Ordningen er fordelt mellom to
              formål: 1. Tilskudd til tiltak i utleieboliger og 2. Tilskudd til tiltak i omsorgsboliger og sykehjem
            </p>
            <p>Husbanken har forvaltet ordningen siden 2023</p>
            <p>
              <strong>Søknad:</strong>Det sendes inn søknad om tilskudd basert på den til enhver tid gjeldende forskrift med tilhørende veileder. Det er kun kommuner som kan søke.
            </p>
            <p>
              <strong>Tilsagn:</strong>Tilskuddet beregnes ut fra en beregningsmodell med normerte verdier for kostnad ved å gjennomføre tiltakene, sammenlignet med en standard i
              markedet. Beregningsmodellen gir også en estimert verdi for energibesparelsen, angitt i kWt.
            </p>
            <p>
              <strong>Utbetaling:</strong>Ved utbetaling legges de faktiske kostnadene til grunn, og utbetalt tilskudd kan ikke overstige 50 % av faktiske, dokumenterte kostnader.
            </p>
            <p>
              <strong>Estimert energibesparelse:</strong>Basert på opplysninger om eiendommen, hvilke tiltak og omfanget av dem, samt antall boliger/plasser tiltakene omfatter,
              blir forventet energibesparelse beregnet og angitt i kWt.
            </p>
            <p>
              <strong>Antall utleieboliger:</strong>Viser samlet antall kommunalt eide utleieboliger som omfattes av tiltakene det er sendt inn søknad for, fått tilsagn eller fått
              utbetalt i perioden som er valgt.
            </p>
            <p>
              <strong>Antall omsorgsboliger/sykehjemsplasser:</strong>Viser samlet antall omsorgsboliger og sykehjemsplasser som omfattes av tiltakene som det er sendt inn søknad
              for, har fått tilsagn eller blitt utbetalt i perioden som er valgt.
            </p>
            <p>
              <strong>Beløp:</strong>Viser beløp for innkomne søknader, gitte tilsagn og prosjekter som er utbetalt. Beløpene viser samlet beløp for utleieboliger, omsorgsboliger
              og sykehjemsplasser.
            </p>
            <h3>Type tiltak:</h3>
            <ul class="hb-list hb-list--gap-none hb-text--sm">
              <li>Etterisolering av yttervegger</li>
              <li>Etterisolering av yttertak/kaldt loft</li>
              <li>Utskifting og oppgradering av vinduer</li>
              <li>Termisk isolering av rør og deler i varmesentral</li>
              <li>Varmepumpe væske til vann</li>
              <li>Varmepumpe luft til vann</li>
              <li>Solvarmekollektor</li>
              <li>Solceller</li>
              <li>Biokjel for fast brensel</li>
            </ul>
          </div>
        </hb-accordion-element>
      </hb-accordion>

      <fieldset class="hb-felt">
        <legend class="hb-screenreader-only">Sorter etter</legend>
        <div class="hb-buttongroup">
          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandSoknad" type="radio" checked="" (click)="filterTilstand('Søknad')" />
          <label class="hb-button hb-button--standard" for="typeTilstandSoknad">Søknad</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandTilsagn" type="radio" (click)="filterTilstand('Tilsagn')" />
          <label class="hb-button hb-button--standard" for="typeTilstandTilsagn">Tilsagn</label>

          <input name="typeTilstand" class="hb-radiobutton" id="typeTilstandUtbetaling" type="radio" (click)="filterTilstand('Utbetaling')" />
          <label class="hb-button hb-button--standard" for="typeTilstandUtbetaling">Utbetaling</label>
        </div>
      </fieldset>

      <div class="hb-grid">
        <stat-kpitabell [kpiIder]="kpiListe" [valgtFilter]="valgtFilter" [statistikkType]="statistikkType" class="hb-cell hb-cell--6of12@md"></stat-kpitabell>
      </div>

      <div class="hb-grid">
        <div class="hb-fieldset hb-cell hb-cell--12of12">
          <div class="hb-legend">
            <div class="hb-legend-tekst" id="hva-du-vil-se" aria-hidden="true">Velg hva du vil se:</div>
            <hb-hjelpetekst labelledby="hva-du-vil-se">
              @for (item of objectKeys(typeTekst[statistikkType]); track item) {
                <div>
                  <p class="hb-avstand--ingen">
                    <strong>{{ typeTekst[statistikkType][item][0] }}:</strong>
                  </p>
                  <p class="hb-mb--md">{{ typeTekst[statistikkType][item][1] }}</p>
                </div>
              }
            </hb-hjelpetekst>
          </div>
          <fieldset class="hb-felt">
            <legend class="hb-screenreader-only">Velg hva du vil se:</legend>
            <ul class="hb-feltliste">
              @for (value of objectKeys(typeTekst[statistikkType]); track value) {
                <li>
                  <input (change)="selectedRadio($event)" class="hb-radiobutton" [id]="value" type="radio" name="radio1" [value]="value" [checked]="value === graferValgt" />
                  <div class="hb-label">
                    <label class="hb-label-tekst" [for]="value">
                      <span>{{ typeTekst[statistikkType][value][0] }}</span>
                    </label>
                  </div>
                </li>
              }
            </ul>
          </fieldset>
          <stat-kommunefilter></stat-kommunefilter>
        </div>
      </div>

      @if (graferValgt === "utleieboliger") {
        <div class="hb-grid">
          @for (utleieId of grafIderForUtleieboliger; track utleieId) {
            <stat-qlik-graf
              id="{{ utleieId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
      @if (graferValgt === "omsorgsykehj") {
        <div class="hb-grid">
          @for (msorgsykehjId of grafIderForOmsorgsykehj; track omsorgsykehjId) {
            <stat-qlik-graf
              id="{{ msorgsykehjId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
      @if (graferValgt === "energibesparelseomsorgboliger") {
        <div class="hb-grid">
          @for (energibesparelseomsorgboligerId of grafIderForEnergiBesparelseOmsorgboliger; track energibesparelseomsorgboligerId) {
            <stat-qlik-graf
              id="{{ energibesparelseomsorgboligerId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
      @if (graferValgt === "energibesparelseutleieboliger") {
        <div class="hb-grid">
          @for (energibesparelseutleieboligerId of grafIderForEnergiBesparelseUteleieboliger; track energibesparelseutleieboligerId) {
            <stat-qlik-graf
              id="{{ energibesparelseutleieboligerId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
      @if (graferValgt === "energibesparelsebelop") {
        <div class="hb-grid">
          @for (belopId of grafIderForEnergiBesparelseBelop; track belopId) {
            <stat-qlik-graf
              id="{{ belopId }}"
              class="hb-cell hb-cell--12of12 hb-cell--6of12@md"
              [statistikkType]="statistikkType"
              [typeTekst]="hentSelectedRadioLabel()"
              [valgtFilter]="valgtFilter"
              [noSelections]="true"
            >
            </stat-qlik-graf>
          }
        </div>
      }
    </div>
  </div>
</div>
